<template>
    <div class="hot-article clear bord" id="hot-news-container" data-spm="tw">
        <div id="hot-news">
            <div class="titleR">
                <span class="tt">24小时热文</span>
            </div>
            <div
                v-for="item in contentArr"
                :key="item"
                class="pic-txt clear"
                data-loc="3"
                :data-ev="item.id"
                :data-media-id="item.authorId"
                data-spm-type="resource"
                :data-spm-content="dataSpmCnt(item)"
                :data-newsid="item.position"
            >
                <div class="pic img-do">
                    <a :href="item.url" target="_blank">
                        <img alt="" :data-src="item.picUrl" :src="preloadUrl"/>
                        <span v-if="item.index" class="sn">{{ item.index }}</span>
                    </a>
                </div>
                <h4>
                    <a target="_blank" :href="item.url" data-spm-type="content">{{
                        item.title
                    }}</a>
                </h4>
                <p>
                    <a :href="item.url" target="_blank" v-if="item.pv">
                        <em data-role="read-count" :data-id="item.id">{{
                            item.pv
                        }}</em>
                        阅读
                    </a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import spmUtils from "@/utils/spm_utils"
import { acodeConfig } from "@/config/spmConfig"
import getAsspAd from '../../components/adver'
import Str from "@/utils/string"
import NumberFix from "@/utils/number-text"
import { setPicSize } from "../../utils/pic-util.js"
import { env } from "@/env"
import { getOdinResourceIdMap,nullResourceId } from '@/config/odinResourceIds'
import { getOdinData,formatOdinData } from "@/request/odinRequest"

const OdinStateCodeMap = {
    SUCCESS: "SUCCESS",
    EMPTY: "EMPTY",
    TIMEOUT: "TIMEOUT",
    ERROR: "ERROR",
}

export default {
    data() {
        return {
            test: false,
            scene: 'HOMEPAGE',
            sceneId: 0,
            news_id: 0,
            media_id: 0,
            channel_id: 0,
            secureScore: 0,
            items: [],
            adArr: [], // 广告数组
            contentArr: [], // 非广告数组
            idsMap: {},
            preloadUrl: "//statics.itc.cn/web/static/images/pic/preload.png",
        }
    },
    computed: {
        //文章等级A
        isSgradeA() {
            return window.pcArticleInfo?.sGrade == 0
        },
        dataSpmCnt() {
            return (item) => {
                return (
                    (item?.resourceType ? item.resourceType : '')  +
                    '|' +
                    (item?.authorId ? item.authorId : '') +
                    '|' +
                    (item?.id ? item.id : '') +
                    '|' +
                    (item?.pcm ? item.pcm : '') +
                    '|' +
                    (item?.type ? item.type : '') +
                    '|' +
                    (item?.adInfo ? item.adInfo : '')
                );
            };
        },
    },
    mounted() {
        this.init()
        this.fetchData()
    },
    methods: {
        init() {
            const pcArticleInfo = window.pcArticleInfo
            this.sceneId = pcArticleInfo?.channel_id
            this.test = env === 'test'
            this.news_id = pcArticleInfo.news_id
            this.channel_id = pcArticleInfo.channel_id
            this.media_id = pcArticleInfo.media_id
            this.secureScore = pcArticleInfo.secureScore
        },
        async fetchData() {
            const spmObj = window?.sohuSpm?.getCodes()
            const senceKey = 'hot24news'
            const idsMap = getOdinResourceIdMap(senceKey)
            const param = {
                tplCompKey: senceKey,
                adInfo: this.isSgradeA ? idsMap?.adInfo : {},
                spmCCode: idsMap?.spmCCode,
                resourceId: this.isSgradeA ? idsMap?.resourceId : nullResourceId,
                content: {
                    page: 1,
                    size: 5,
                    productId: idsMap?.productId,
                    productType: idsMap?.productType,
                    spm: `${spmObj?.a}.${spmObj?.b}.${idsMap?.spmCCode}`
                },
                context:{
                    mkey: "channelId_" + this.channel_id + "--mpid_" + this.news_id
                }
            }
            let reportInfo = this.getReportInfo(param)
            if(param.resourceId != nullResourceId) {
                spmUtils.sendAction(acodeConfig.adRequest, reportInfo.join(';'))
            }
            try {
                let res = await getOdinData(param)
                if(res?.list?.length) {
                    let list = formatOdinData(res)
                    reportInfo.push('code:' + OdinStateCodeMap.SUCCESS)
                    let adLocations = []
                    list.forEach(function (item, index) {
                        if (item.adType) {
                            adLocations.push(index + 1)
                        }
                    })
                    if (adLocations.length > 0) {
                        reportInfo.push('n:' + JSON.stringify(adLocations))
                    }
                    if(param.resourceId != nullResourceId) {
                        spmUtils.sendAction(
                        acodeConfig.adRequestComplete,
                        reportInfo.join(';')
                    )
                    }
                    this.getHotNewsData(list)
                    this.$nextTick(() => {
                        this.renderAd(this.adArr)
                        if (window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
                            window.sohuSpm.domDidChange({ target: 'tw' });
                        }
                    })
                    }else {
                        reportInfo.push('code:' + OdinStateCodeMap.EMPTY)
                        if(param.resourceId != nullResourceId){
                            spmUtils.sendAction(
                                acodeConfig.adRequestComplete,
                                reportInfo.join(';')
                            )
                        }
                    }
                setTimeout(()=>{
                    window?.LazyLoadIns?.scanImg()
                })
            } catch (error) {
                console.log('24h',error)
                reportInfo.push('code:' + OdinStateCodeMap.ERROR)
                if(param.resourceId != nullResourceId){
                    spmUtils.sendAction(
                        acodeConfig.adRequestComplete,
                        reportInfo.join(';')
                    )
                }
            }
        },

        getHotNewsData(list) {
            this.items = list.slice(0, 5)
            this.items.forEach((o, index) => {
                o.position = index
                o.index = index < 3 ? index + 1 : undefined // 内容流数字标
                o.adData && (o.adData.index = index < 3 ? index + 1 : undefined) // 推广位数字标
                if (o.adType) {
                    this.adArr.push(o)
                } else {
                    o.picUrl = setPicSize(o.images?.[0], 180, 120) || o.images?.[0] || '';
                    o.title = Str.subString(o.title, 25);
                    if(o.pv) o.pv = this.formatPv(o.pv)
                    this.contentArr.push(o); // 普通流
                }
            })
        },
        renderAd(data) {
            data.forEach(item => {
                const randomId = Math.random().toString(30).slice(6) + '_';
                const id = '#' + randomId;
                const loc = item.position - 1; // 找到当前位置前面的信息
                const spmDCodeIndex = item.location
                const adType = item.adType
                item.spmLoc = 'tw.' + spmDCodeIndex
                if(item.adData)item.adData.pv = this.getRandomReadCount() // 设置随机阅读数
                const targetDiv = document.querySelector(`#hot-news div[data-newsid='${loc}']`)
                var newDiv = document.createElement('div')
                newDiv.setAttribute('data-spm-data',spmDCodeIndex)
                newDiv.setAttribute('class','pic-txt clear')
                newDiv.setAttribute('id',randomId)
                targetDiv?.parentNode?.insertBefore(newDiv, targetDiv.nextSibling)
                const adTemplateMap = {
                    SOHUZH: {
                        MixPic: _.template(require('../../components/adver/SOHUZH/hot-news-ad.html')),
                        default: _.template(require('../../components/adver/SOHUZH/hot-news-ad.html'))
                    }
                }
                getAsspAd({
                    data: item,
                    el: document.getElementById(randomId),
                    spmCode: item.spmLoc,
                    resourceId: this.resourceId,
                    component: adTemplateMap[adType]
                })
            })
        },
        // 上报
        getReportInfo(resourceParam) {
            const resourceId = resourceParam.resourceId
            let reportInfo = []
            reportInfo.push('resourceId:' + resourceId)
            reportInfo.push('location:' + resourceParam.content.spm)
            if (resourceParam.content.page) {
                reportInfo.push('pg:' + resourceParam.content.page)
            }
            if (resourceParam.content.size) {
                reportInfo.push('sz:' + resourceParam.content.size)
            }
            return reportInfo
        },
        // 获取随机阅读数，用于推广模拟阅读数
        getRandomReadCount() {
            const randomNum = 1000000 + parseInt(Math.random() * 10) * 100000
            const c = new NumberFix(randomNum).format()
            return c
        },
        formatPv(pv) {
            let readCount = new NumberFix(pv).format()
            if (parseInt(readCount) == 0) {
                readCount = "&nbsp;";
            }
            return readCount
        },
    }
};
</script>
<style lang="less">
.titleR{height:25px;padding:16px 20px 8px;color:#191919;line-height:25px;text-align:right;position:relative;}
.titleR .tt{font-size:20px;float:left;font-weight:bold;}
/* hot-article */
.hot-article{padding-bottom:10px;height:auto;}
.hot-article .pic:hover img{transform: matrix(1.04, 0, 0, 1.04, 0, 0);backface-visibility: hidden;}
.hot-article .pic-txt{padding:10px 0;margin:0 auto;width:300px;}
.hot-article .pic-txt .pic{width:90px;height:60px;margin-right:10px;float:left;overflow:hidden;position:relative;
                           border-top: 1px solid rgba(0, 0, 0, 0.05);
                           border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                           border-left: 1px solid rgba(0, 0, 0, 0.05);
                           border-right: 1px solid rgba(0, 0, 0, 0.05);}

.hot-article .pic-txt h4{font-size:14px;line-height:22px;padding-top:6px;}
.hot-article .pic-txt .sn{width:100%;height:40px;padding-top:20px;background-color:rgba(0,0,0,0.3);position:absolute;left:0;top:0;color:#fff;font-size:24px;font-weight:bold;text-indent:10px;}
//24小时热文添加新样式
.hot-article .pic-txt {
    padding: 8px 0;
    p {
        text-align: left;
        padding-top: 4px;
        line-height: 1;
        color: #999;
        a {
            color: #999;
            &:hover {
                color: #c9141d;
            }
        }
    }
    h4 {
        padding-top: 0;
        height: 44px;
        overflow: hidden;
    }
}
</style>
